import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "notes"
}
const _hoisted_3 = {
  key: 0,
  class: "notes-list"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.notes.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(note), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "Add notes for this lesson")),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleInput && _ctx.toggleInput(...args)))
          }, "Add note")
        ]))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNote && _ctx.addNote(...args)), ["prevent"]))
        }, [
          _createVNode(_component_ion_icon, {
            class: "close-icon",
            name: "close-circle-outline",
            onClick: _ctx.toggleInput
          }, null, 8, ["onClick"]),
          _withDirectives(_createElementVNode("textarea", {
            name: "note",
            id: "note",
            "aria-label": "Enter note here",
            placeholder: "Enter note here",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.note) = $event))
          }, null, 512), [
            [_vModelText, _ctx.note]
          ]),
          _createElementVNode("button", {
            type: "submit",
            disabled: !_ctx.note
          }, "Save", 8, _hoisted_5)
        ], 32))
  ]))
}